import {
  Backdrop, Button, Card, CardActions, CardContent, CardHeader, CircularProgress, Container, Dialog,
  DialogActions, DialogContent, DialogTitle, Divider, Grid, LinearProgress,
  Select, Slide, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField
  , FormControl, InputLabel, MenuItem, FormHelperText
} from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CloseIcon from '@material-ui/icons/Close';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import SendIcon from '@material-ui/icons/Send';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { CustomTableCell } from 'src/components/CustomTableCell';
import GenericBulten from 'src/components/GenericBulletin';
import Page from 'src/components/Page';
import AddressSearch from 'src/components/Selects/AddressSearch';
import MaterialSearch from 'src/components/Selects/MaterialSearch';
import axios from "src/utils/axios";
import { CreateWareHouseAddress, getUser, GetWarehouseAddress } from 'src/utils/Common';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  container: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  containerIc: {
    width: '100%',
    overflowX: 'auto',
    maxHeight: 100,
  },
  containersag: {
    width: '100%',
    maxHeight: 567,
    minHeight: 567,
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  cardScrollUst: {
    overflowY: "auto",
    margin: 1,
    padding: 1,
    maxHeight: 400,
    minHeight: 400,
    listStyle: "none",
    height: "100%",
    '&::-webkit-scrollbar': {
      width: '1em'
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
      outline: '1px solid slategrey'
    }
  },

}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ArcelikReturn() {
  const classes = useStyles();
  const [FaturaNo, setFaturaNo] = useState('');
  const [NedenAciklama, setNedenAciklama] = useState('');
  const [description, setDescription] = useState('');
  const [material, setMaterial] = useState('');
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [rowIndex, setRowIndex] = useState(0);
  const [WarehouseAddress, setWarehouseAddress] = useState([]);
  const [bultenOpen, setBultenOpen] = React.useState(false);
  const [LoadingMaterial, setLoadingMaterial] = React.useState(false);
  const [bultenParam, setBultenParam] = React.useState('');
  const [ImageUrl, setImageUrl] = useState(null);
  const [openMaterialFile, setOpenMaterialFile] = React.useState(false);
  const [openMaterialFileTitle, setOpenMaterialFileTitle] = React.useState("");
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [Neden, setNeden] = useState("0");
  const [data, setData] = useState({});
  const SessionUser = getUser();
  const [ambalaj, setAmbalaj] = useState('');
  const [hasar, setHasar] = useState('');

  const ambalajOptions = [
    { value: '0', desc: 'Ambalaj durumu seçiniz...' },
    { value: '1', desc: 'Ambalaj sağlam' },
    { value: '2', desc: 'Ambalaj hasarlı' },
  ];

  const hasarIadeNedeniOptions = [
    { value: '0', desc: 'Hasar İade Nedeni seçiniz...' },
    { value: '1', desc: 'Vuruk' },
    { value: '2', desc: 'Kırık' },
    { value: '3', desc: 'Çatlak' },
    { value: '4', desc: 'Çizik' },
    { value: '5', desc: 'Emaye Atık' },
  ];


  useEffect(() => {
    CreateWareHouseAddress(SessionUser.ServiceShopId);
    var DegerWarehouseAddress = [];
    DegerWarehouseAddress = GetWarehouseAddress(SessionUser.ServiceShopId);
    setWarehouseAddress(DegerWarehouseAddress);
  }, []);

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  var DepoAdet = 0;
  var KdvliFiyat = 0;

  const addSaleRows = (newPage) => {
    if (SessionUser.ServiceVisibleList == 1 && newPage.Neden === "Y05") {
      setUyariTip('error');
      setUyariAciklama("Aktif servisler Kapanan Servis iade nedeni ile işlem yapamaz!...");
      setUyari(true);
      return;
    }
    if (newPage.data.isComplementaryProduct === 1 && (newPage.Neden === "Y12" || newPage.Neden === "Y13")) {
      setUyariTip('error');
      setUyariAciklama("Tamamlayıcı ürünler seçimini yapmak istediğiniz iade nedeni ile iade edilemez!...");
      setUyari(true);
      return;
    }
    if (newPage.data.materialCode === undefined) {
      setUyariTip('error');
      setUyariAciklama("Malzeme seçimi yapmanız gerekiyor.Lütfen kontrol ediniz!...");
      setUyari(true);
      return;
    }
    if (parseInt(Neden) === 0) {
      setUyariTip('error');
      setUyariAciklama("İade nedeni seçiniz!...");
      setUyari(true);
      return;
    }
    if (Neden === 'Y03' && ambalaj === "") {
      setUyariTip('error');
      setUyariAciklama("Ambalaj durumunu seçiniz!...");
      setUyari(true);
      return;
    }
    if (Neden === 'Y03' && hasar === "") {
      setUyariTip('error');
      setUyariAciklama("Hasar iade nedenini seçiniz!...");
      setUyari(true);
      return;
    }
    if (description === "") {
      setUyariTip('error');
      setUyariAciklama("Açıklama giriniz!...");
      setUyari(true);
      return;
    }

    //İade nedeni Kapanan Servis olanların sayısı 200'ü geçemez.
    if (JSON.parse(JSON.stringify(rows)).filter(i => i.Neden === "Y05").length == 200) {
      setUyariTip('error');
      setUyariAciklama("Kapanan servisler için tek seferde yapılabilecek maksimum iade adedi 200'dür.");
      setUyari(true);
      return;
    }
    //Kapanan Servis olmayanların sayısı 20'yi geçemez.
    if (JSON.parse(JSON.stringify(rows)).filter(i => i.Neden !== "Y05").length == 20) {
      setUyariTip('error');
      setUyariAciklama("Tek seferde yapılabilecek maksimum iade adedi 20'dir.");
      setUyari(true);
      return;
    }

  const devamEtDepoGetir = () => {
    axios.get(`GetDepoAdetFiyat/${newPage.data.materialCode}/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}`)
      .then(response => {
        let [DepoAdet, KdvliFiyat, ADRES_ADET, WarehouseAddressText, WarehouseAddress] = response.data.split('|');
        let varMi = rows.filter(d => d.MaterialCode.replace(/^0+/, '') === newPage.data.materialCode);
        if (varMi.length > 0) {
          let filteredRowIndex = rows.findIndex(d => d.MaterialCode.replace(/^0+/, '') === newPage.data.materialCode);
          rows.splice(filteredRowIndex, 1);
          varMi[0].Count = parseInt(varMi[0].Count) + 1;
          varMi[0].DEPO_ADET = DepoAdet;
          varMi[0].KDVLIFIYAT = KdvliFiyat;
          varMi[0].ADRES_ADET = ADRES_ADET;
          varMi[0].WarehouseAddressText = WarehouseAddressText;
          varMi[0].WarehouseAddress = WarehouseAddress;
          setRows([...rows, varMi[0]]);
        } else {
          setRowIndex(rowIndex + 1);
          let row = {
            index: rowIndex,
            FaturaNo: newPage.FaturaNo,
            NedenAciklama: newPage.NedenAciklama,
            Neden: newPage.Neden,
            Description: newPage.description,
            MaterialCode: newPage.data.materialCode,
            MaterialDesc: newPage.data.materialDesc,
            MaterialId: newPage.data.materialId,
            Count: 0,
            DEPO_ADET: DepoAdet,
            ADRES_ADET: ADRES_ADET,
            WarehouseAddressText: WarehouseAddressText,
            WarehouseAddress: WarehouseAddress,
            KDVLIFIYAT: KdvliFiyat,
            AmbalajDurumu: newPage.ambalaj === '' ? 0 : newPage.ambalaj,
            HasarIadeNedeni: newPage.hasar === '' ? 0 : newPage.hasar
          };
          setRows([...rows, row]);
        }
        if (newPage.Neden === 'Y03') {
          setAmbalaj('');
          setHasar('');
        }
      })
      .catch(error => {
        setUyariTip('error');
        setUyariAciklama("Depo bilgileri alınamadı.");
        setUyari(true);
      });
    }

        if (newPage.Neden === 'Y12') {
    axios.get(`SiparisTipKontrolu/${FaturaNo}/${SessionUser.ServiceShopCode}/${newPage.data.materialCode}`)
      .then(response => {
        if (parseInt(response.data) === 0) {
          devamEtDepoGetir();
        } else {
          setUyariTip('error');
          setUyariAciklama(" 'ST' tipindeki siparişler iade edilemez.");
          setUyari(true);
        }
      })
      .catch(error => {
        setUyariTip('error');
        setUyariAciklama("Sipariş tipi kontrolü yapılırken hata oluştu.");
        setUyari(true);
      });
  } else {
    devamEtDepoGetir();
  }

    if (newPage.Neden === 'Y03') {
      setAmbalaj('');
      setHasar('');
    }


  };
  const onChange = (e, row) => {
    var value = e.target.value;
    const name = e.target.name;
    if (parseInt(value) < 0) {
      value = 1;
    }
    const { index } = row;
    const newRows = rows.map(row => {
      if (row.index === index) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setRows(newRows);
  };

  const handleChangeMaterial = (material) => {
    if (material != undefined) {
      let old_rows = { materialId: material.MaterialId, materialCode: material.MaterialCode, materialDesc: material.MaterialDesc, isComplementaryProduct: material.IsComplementaryProduct };
      setData(old_rows);
    }
  }
  const GetMaterialImage = (materialCode) => {
    setOpenMaterialFile(true);
    setLoadingMaterial(true);
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    setOpenMaterialFileTitle(materialCode + " Numaralı Malzeme Detayı");
    axios.get(`MaterialFile/${materialCode}`, config)
      .then(response => {
        var fileURL = URL.createObjectURL(response.data);
        setImageUrl(fileURL);
        setLoadingMaterial(false);
      }).catch(error => {
        setLoadingMaterial(false);
      });
  }
  const GetMaterialBulletin = (materialCode) => {
    setBultenParam(materialCode);
    setBultenOpen(true);
  }

  const SetMalzemeCikar = (rowIndex) => {
    confirmAlert({
      message: "Malzeme satış listesinden çıkartılacaktır!... Devam etmek istediğinizden emin misiniz?",
      buttons: [
        {
          label: 'Evet',
          onClick: () => { SetMalzemeCikarKabul(rowIndex); }
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  }
  const SetMalzemeCikarKabul = (index) => {
    var rowsYedek = [...rows];
    rowsYedek.splice(index, 1);
    setRows(rowsYedek);
  }
  const handleCloseMaterialFile = () => {
    setOpenMaterialFile(false);
  };
  const saveExits = () => {


    var Varmi = rows.filter(d => parseInt(d.Count) < 1);
    var VarmiAdres = rows.filter(d => d.WarehouseAddress === undefined);


    const KontrolAdet = rows.filter(d => parseInt(d.Count) > parseInt(d.ADRES_ADET) && d.Neden != 'Y07');

    if (KontrolAdet.length > 0) {
      setUyariTip('error');
      setUyariAciklama("İade yapılmaya çalışılan malzeme adedi depo adres adedinden fazla lütfen kontrol ediniz!...");
      setUyari(true);
      return;
    }

    if (Varmi.length > 0) {
      setUyariTip('error');
      setUyariAciklama("İade adedi girilmedi!..Lütfen kontrol ediniz!...");
      setUyari(true);
      return;
    }
    if (VarmiAdres.length > 0) {
      setUyariTip('error');
      setUyariAciklama("Malzeme adresi girilmedi!..Lütfen kontrol ediniz!...");
      setUyari(true);
      return;
    }

    let data = [];
    rows.forEach(m => {
      data = [...data, {
        BIRIM_KODU: SessionUser.ServiceShopId,
        MALZEME_KODU: m.MaterialId,
        DEPO_ADRES_ID: m.WarehouseAddress,
        CIKIS_TIPI: 7,
        ADET: m.Count,
        FATURA_NO: m.FaturaNo,
        KULLANICI: SessionUser.TechnicianId,
        NEDEN: m.Neden || "0",
        ACIKLAMA: m.Description,
        ServiceShopCode: SessionUser.ServiceShopCode,
        AMBALAJ_DURUMU: m.AmbalajDurumu,
        HASAR_IADE_NEDENI: m.HasarIadeNedeni,
      }]
    });
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };

    setLoading(true);
    axios.post('/SetArcelikIade', data, config)
      .then(response => {
        setLoading(false);
        let ResponseData = response.data[0];
        if (parseInt(ResponseData.ErrorCode) === 0) {
          setUyariTip('success');
          setUyariAciklama(ResponseData.ErrorDescription);
          setUyari(true);
          setRows([]);
          setFaturaNo("");
          setDescription("");
          setData({});
        }
        else {
          if (ResponseData.ErrorDescription.includes("numarali iade belgeniz") == true) {
            setUyariTip('success');
            setUyariAciklama(ResponseData.ErrorDescription);
            setUyari(true);
            setRows([]);
            setFaturaNo("");
            setDescription("");
            setData({});
          }
          else {
            setUyariAciklama(ResponseData.ErrorDescription);
            setUyariTip('error');
            setUyari(true);
          }
        }

      }).catch(error => {
        setLoading(false);
      });
  };

  const search = "";

  const setAdres = (param, index, MALZEME_STOK_NO) => {
    axios.get(`/GetAdresMalzemeKullanilabilirAdet/${SessionUser.ServiceShopId}/${param.Id}/${MALZEME_STOK_NO}`)
      .then(response => {
        let old_rows = [...rows];
        old_rows[index].WarehouseAddress = param?.Id || 0;
        old_rows[index].WarehouseAddressText = param?.Description || 0;
        old_rows[index].Malzemeleri = param?.Materials || 0;
        old_rows[index].ADRES_ADET = response.data;
        setRows(old_rows);
      })
      .catch(error => {
        console.log(error);
      });
  }


  const handleNedenChange = (event) => {

    var index = event.target.selectedIndex;
    setNedenAciklama(event.target[index].text);
    setNeden(event.target.value);
    setAmbalaj('');
    setHasar('');
  };

  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container maxWidth="xl">
        <Card>
          <CardHeader title="Arçelik Malzeme İade" />
          <Snackbar open={uyari} autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={uyariKapat}>
            <Alert onClose={uyariKapat} severity={uyariTip}>
              {uyariAciklama || ''}
            </Alert>
          </Snackbar>
          <Divider />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={3}>
                <Card className={classes.container}>
                  <CardHeader title="İade" />
                  <Divider />
                  <CardContent>
                    <TextField
                      label="Fatura No"
                      value={FaturaNo}
                      variant="outlined"
                      onChange={event => { setFaturaNo(event.target.value) }}
                      fullWidth
                    />
                    <br /><br />
                    <MaterialSearch
                      label={"Malzeme"}
                      value={{
                        MaterialId: data.materialId,
                        MaterialCode: data.materialCode,
                        MaterialDesc: data.materialDesc
                      }}
                      setValue={(material) => handleChangeMaterial(material)}
                      showHelper={true}
                    />
                    <br /><br />
                    <Select
                      variant="outlined"
                      fullWidth
                      native
                      value={Neden} onChange={handleNedenChange}>
                      <option value="0">Neden seçiniz...</option>
                      {/* <option value="Y02">Demode</option> */}
                      <option value="Y03">Hasarlı</option>
                      {/* <option value="Y04">Paslaşma</option> */}
                      <option value="Y05">Kapanan Servis</option>
                      {/* <option value="Y06">Kilitli Stok</option> */}
                      <option value="Y07">Eksik Malzeme</option>
                      <option value="Y09">Stok Hatası</option>
                      <option value="Y10">Arızalı Malzeme</option>
                      {/* <option value="Y11">Yönetim Onaylı</option> */}
                      <option value="Y12">İlk 15 Gün</option>
                      <option value="Y13">Planlama Fazlası</option>
                      {/* <option value="Y14">Ürün Değişim</option> */}
                    </Select>
                    {Neden === 'Y03' && (<><br /><br />
                      <Select
                        variant="outlined"
                        fullWidth
                        native
                        value={ambalaj}
                        onChange={e => setAmbalaj(e.target.value)}
                      >
                        {ambalajOptions.map((item) => (
                          <option key={item.value} value={item.value}>{item.desc}</option>
                        ))}
                      </Select>
                      <br /><br />
                      <Select
                        variant="outlined"
                        fullWidth
                        native
                        value={hasar}
                        onChange={e => setHasar(e.target.value)}
                      >
                        {hasarIadeNedeniOptions.map((item) => (
                          <option key={item.value} value={item.value}>{item.desc}</option>
                        ))}
                      </Select></>)}
                    <br /><br />
                    <TextField
                      label="Açıklama"
                      rows={8}
                      multiline={true}
                      variant="outlined"
                      value={description}
                      onChange={event => { setDescription(event.target.value) }}
                      fullWidth
                    />
                  </CardContent>
                  <CardActions>
                    <Button
                      variant="contained"
                      color="secondary"
                      fullWidth
                      endIcon={<AddCircleOutlineIcon></AddCircleOutlineIcon>}
                      onClick={() => addSaleRows({ FaturaNo, description, data, NedenAciklama, Neden, ambalaj, hasar })}
                    >
                      Ekle
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item xs={12} sm={9}>
                <Card className={classes.containersag}>
                  <CardHeader
                    title="İşlemler"
                    action={
                      <Button
                        variant="contained"
                        className={classes.button}
                        color="secondary"
                        endIcon={<SendIcon></SendIcon>}
                        onClick={() => saveExits()}
                      >
                        İade Et
                      </Button>
                    }
                  />
                  <Divider />
                  <CardContent>
                    <TableContainer style={{ width: '100%' }} className={classes.cardScrollUst}>
                      <Table
                        className={classes.table}
                        size="small"
                        stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell padding='none' align="left">Fatura</TableCell>
                            <TableCell padding='none' align="left">Neden</TableCell>
                            <TableCell padding='none' align="left">MalzemeStokNo</TableCell>
                            <TableCell padding='none' align="left">Malzeme</TableCell>
                            <TableCell padding='none' align="left">KdvliFiyat</TableCell>
                            <TableCell padding='none' align="left">DepoAdet</TableCell>
                            <TableCell padding='none' align="left">AdresAdet</TableCell>
                            <TableCell padding='none' align="center">İadeAdet</TableCell>
                            <TableCell padding='none' align="center" width="200">Adres</TableCell>
                            <TableCell padding='none' align="center">Ambalaj</TableCell>
                            <TableCell padding='none' align="center">Hasar</TableCell>
                            {/* <TableCell padding='none' align="center">Resim</TableCell>
                            <TableCell padding='none' align="center">Bülten</TableCell> */}
                            <TableCell padding='none' align="center">Sil</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows.map((row, index) => (
                            <TableRow key={index}>
                              <TableCell padding='none' align="left" className={classes.tableCell}>
                                {row.FaturaNo}
                              </TableCell>
                              <TableCell padding='none' align="left" className={classes.tableCell}>
                                {row.NedenAciklama}
                              </TableCell>
                              <TableCell padding='none' align="left" className={classes.tableCell}>
                                {row.MaterialCode.replace(/^0+/, '')}
                              </TableCell>
                              <TableCell padding='none' align="left" title={row.MaterialDesc} className={classes.tableCell}>
                                {(row.MaterialDesc.length) > 20 ? row.MaterialDesc.substring(0, 20) + '...' : row.MaterialDesc}
                              </TableCell>
                              <TableCell padding='none' align="left" title={row.MaterialDesc} className={classes.tableCell}>
                                {row.KDVLIFIYAT + " ₺"}
                              </TableCell>
                              <TableCell
                                align="left"
                                padding='none'
                                className={classes.tableCell}
                              >
                                {parseInt(row.DEPO_ADET) > 0 ? (
                                  parseInt(row.DEPO_ADET, 10)
                                ) : (
                                  <b style={{ color: 'red' }}>
                                    {parseInt(row.DEPO_ADET, 10)}
                                  </b>
                                )}
                              </TableCell>
                              <TableCell
                                align="left"
                                padding='none'
                                className={classes.tableCell}
                              >
                                {parseInt(row.ADRES_ADET) > 0 ? (
                                  parseInt(row.ADRES_ADET, 10)
                                ) : (
                                  <b style={{ color: 'red' }}>
                                    {parseInt(row.ADRES_ADET, 10)}
                                  </b>
                                )}
                              </TableCell>
                              <CustomTableCell {...{ row, name: "Count", onChange, Adet: row.ADRES_ADET }} />

                              <TableCell padding='none' align="center">
                                {
                                  row.DEPO_ADET > 0 ?
                                    <AddressSearch
                                      setAdres={setAdres}
                                      value={{
                                        Id: row.WarehouseAddress || '0',
                                        Description: row.WarehouseAddressText || 'Adres Seçiniz!...',
                                        Materials: row.Malzemeleri | ''
                                      } || ''}
                                      searchParam={search}
                                      MaterialCode={row.MaterialCode.replace(/^0+/, '')}
                                      ServicePaperNr={0}
                                      index={index}
                                      Adres={row.WarehouseAddress || 0}
                                      RowSelected={1}
                                      Tip={"Cikis1"}
                                    />
                                    :
                                    <TextField
                                      type="text"
                                      disabled
                                      value={"Malzeme Adresi Bulunmuyor!.."}
                                      fullWidth
                                    />
                                }
                              </TableCell>
                              <TableCell
                                align="center"
                                padding='none'
                                className={classes.tableCell}
                              >
                                {row.AmbalajDurumu ? ambalajOptions.filter(x => x.value === row.AmbalajDurumu)[0].desc : '-'}
                              </TableCell>
                              <TableCell
                                align="center"
                                padding='none'
                                className={classes.tableCell}
                              >
                                {row.HasarIadeNedeni ? hasarIadeNedeniOptions.filter(x => x.value === row.HasarIadeNedeni)[0].desc : '-'}
                              </TableCell>
                              {/* <TableCell padding='none' align="center" className={classes.tableCell}>
                                <ImageSearchIcon
                                  onClick={() => GetMaterialImage(row.MaterialCode.replace(/^0+/, ''))}
                                  color="primary" />
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                <FindInPageIcon
                                  onClick={() => GetMaterialBulletin(row.MaterialCode.replace(/^0+/, ''))}
                                  color="primary" />
                              </TableCell> */}
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                <DeleteForeverIcon
                                  onClick={() => SetMalzemeCikar(index)}
                                  color="error" />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={bultenOpen}
        onClose={() => setBultenOpen(false)}
        TransitionComponent={Transition}
        keepMounted
      >
        <DialogTitle id="alert-dialog-title">
          Malzemeye Ait Bültenler</DialogTitle>
        <DialogContent>
          {LoadingMaterial ? <LinearProgress
            status="loading"
          /> : <GenericBulten param={bultenParam} />}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => { setBultenOpen(false); }}
            className={classes.button}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openMaterialFile}
        // TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseMaterialFile}      >
        <DialogTitle>
          {openMaterialFileTitle}
        </DialogTitle>
        <DialogContent>
          {LoadingMaterial ? <LinearProgress
            status="loading"
          /> : <img style={{ width: '100%' }} alt='' src={ImageUrl} />}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMaterialFile} color="primary">
            Kapat</Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default ArcelikReturn;
